import { DataCategories, DiagnosticLevel, LoggingLevel } from '@augloop/interfaces';
import { LoggingAggregator } from '@augloop/logging';
const US_PER_MS = 1e3;
export const createOperationLoggingAggregator = (eventName, operationNameField, operationNamesToAggregateOnSuccess, telemetryAggregationIntervalSec) => new LoggingAggregator(eventName, (obj) => obj.success && operationNamesToAggregateOnSuccess.indexOf(obj[operationNameField]) >= 0, 
// Dimensions
[
    operationNameField,
    'resourceId',
    'success',
    'resultSignature',
    'clientDocSessionId',
    'dimension0',
    'dimension1',
    'dimension2',
    'dimension3'
], 
// Measures
['durationMs'], telemetryAggregationIntervalSec);
export class TelemetryLogger {
    constructor(hostCallbacks) {
        this.level = LoggingLevel.info;
        this.hostCallbacks = hostCallbacks;
    }
    /* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
    log(obj) {
        if (this.hostCallbacks == null || this.hostCallbacks.sendTelemetryEvent == null) {
            return;
        }
        const logToHost = (op, opName, dataFields, ariaTenant, ariaNamespace) => {
            let operationName = opName.charAt(0).toUpperCase() + opName.slice(1);
            let fieldsToLog = {
                DocSessionId: op.clientDocSessionId,
                ResourceId: op.resourceId,
                ResultDescription: op.resultDescription,
                ResultSignature: op.resultSignature,
                Dimension0: op.dimension0,
                Dimension1: op.dimension1,
                Dimension2: op.dimension2,
                Dimension3: op.dimension3,
                JoinContextId: op.joinContextId
            };
            if (dataFields) {
                fieldsToLog = Object.assign(Object.assign({}, fieldsToLog), JSON.parse(dataFields));
            }
            // if ariaTenant is not provided set to AugLoop Aria
            const ariaTenantToken = ariaTenant ? ariaTenant : TelemetryLogger.augLoopAriaTenantToken;
            const namespaceToken = (!ariaNamespace && ariaTenantToken == TelemetryLogger.augLoopAriaTenantToken) ? TelemetryLogger.augLoopAriaNamespace : ariaNamespace;
            // if operation name is not provided set to placeholder name
            operationName = operationName ? operationName : TelemetryLogger.operationNamePlaceholder;
            this.hostCallbacks.sendTelemetryEvent(ariaTenantToken, namespaceToken ? `${namespaceToken}_${operationName}` : operationName, fieldsToLog, 'Office.System.Activity', {
                CV: op.cv,
                Duration: (op.durationMs || 0) * US_PER_MS,
                Count: op.count,
                AggMode: 2 /*OnSuccess*/,
                Success: op.success
            }, false /*critical*/, 
            /* All AugLoop events currently log as Usage/Performance RSD */
            DataCategories.ProductServiceUsage | DataCategories.ProductServicePerformance, DiagnosticLevel.RequiredServiceDataEvent);
        };
        const logDiagnosticTrace = (tagId, level, message) => {
            if (this.hostCallbacks.sendDiagnosticTrace) {
                this.hostCallbacks.sendDiagnosticTrace(tagId, level, message);
            }
        };
        if (obj.category == 'Workflow.MetricsOnly') {
            // skip metrics only event
        }
        else if (obj.eventName === 'Operation') {
            const op = obj;
            logToHost(op, op.operationName, op.dataFields);
        }
        else if (obj.eventName === 'SessionHealth') {
            const she = obj;
            logToHost(she, she.sessionHealthEventName);
        }
        else if (obj.eventName === 'WorkflowOperation') {
            const wfOp = obj;
            logToHost(wfOp, wfOp.operationName, wfOp.dataFields, wfOp.ariaTenant, wfOp.ariaNamespace);
        }
        else if (obj.eventName === 'Log') {
            logDiagnosticTrace(obj.tagId, obj.traceLevel, obj.message);
        }
    }
}
TelemetryLogger.augLoopAriaTenantToken = '3de4087d4de34817b1c376e3d1e6e293-983c4292-5ba9-485a-ab10-9797863c788b-6770';
TelemetryLogger.augLoopAriaNamespace = 'Office_AugLoop_Client';
TelemetryLogger.operationNamePlaceholder = 'OperationNameNotProvided'; // if operation name is not provided use placeholder
//# sourceMappingURL=telemetry-logger.js.map